import React, { useState } from 'react';
import SideBar from '../../components/SideBar';
import { useLocation } from 'react-router';
import { isEqual } from '../../contexts/Utils';
import { Badge, Empty, Popover } from 'antd';
import { routes } from '../../router/routes';
// Command palette replaces the top-bar search
import { RiNotification3Line } from 'react-icons/ri';
import { FilterProvider } from '../../contexts/FilterContext';
import CommandPalette from '../../components/CommandPalette';

type Props = {
  children: React.ReactComponentElement<never> | React.ReactElement;
};
const MainLayout = ({ children }: Props) => {
  const { pathname } = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const onClose = () => setIsOpen(false);
  const onOpen = () => setIsOpen(true);

  const path = routes.find(({ path }) => isEqual(path, pathname));

  const Notification = () => (
    <div className="bg-white p-5">
      <Empty />
    </div>
  );
  return (
    <div className="w-full h-screen flex">
      <SideBar isOpen={isOpen} onClose={onClose} onOpen={onOpen} />
      <div className="w-full h-full overflow-y-auto scrollbar-thin">
        <div className="w-full sticky top-0 bg-white border-b border-outline flex justify-between items-end p-3 px-5 md:px-10 z-20">
          <div className="">
            <p className="text-lg font-normal text-secondary">{path?.label}</p>
            <p className="text-sm font-normal text-gray">{path?.description}</p>
          </div>
          <div className="flex items-center gap-5">
            <CommandPalette />
            <Popover content={<Notification />}>
              <Badge dot>
                <RiNotification3Line className="!text-xl" />
              </Badge>
            </Popover>
          </div>
        </div>
        <FilterProvider>
          <div className="w-full p-5 md:px-10">{children}</div>
        </FilterProvider>
      </div>
    </div>
  );
};

export default MainLayout;
